import RoutesMap from '../../route_control/RouteControl'
import { ClassList } from '../../pages/class'

export const ClassRouteImport = {
    RoutesMap,
    ClassList,
}
